(function () {
  if (window.__cartAnnouncementInit) return;
  window.__cartAnnouncementInit = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;

  function updateAnnouncement() {
    if (!document.querySelector('.js-cart-announcement')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.js-cart-announcement').forEach(function (bar) {
          var id = Number(bar.dataset.productId);
          var inCart = cart.items.some(function (item) { return item.product_id === id; });
          bar.hidden = inCart || cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return origFetch.apply(this, arguments).then(function (res) {
      if (CART_MUTATION.test(url)) updateAnnouncement();
      return res;
    });
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(url)) this.addEventListener('load', updateAnnouncement);
    return origOpen.apply(this, arguments);
  };

  window.addEventListener('pageshow', updateAnnouncement);
})();